import React from "react";
import Html from "./Html";

const _404Error = () => {
    return (
        <Html/>
    );
}

export default _404Error;